import React, { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "./Carousel.scss";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { serverFiles } from "../../../utils/utils";
import { likeAPost, unlikeAPost } from "reducer/postsSlice";
import { useDispatch } from "react-redux";
import ImageModal from "components/Modal/ImageModal";
import ZoomableImage from "../ZoomableImage/ZoomableImage";

const CustomPrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev" onClick={onClick}>
    <FaArrowLeft />
  </div>
);

const CustomNextArrow = ({ onClick }) => (
  <div className="custom-arrow next" onClick={onClick}>
    <FaArrowRight />
  </div>
);

const settings = {
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplaySpeed: 3000,
  adaptiveHeight: true,
  appendDots: (dots) => (
    <div>
      <ul style={{ margin: "0px" }}> {dots} </ul>
    </div>
  ),
  customPaging: (i) => <div className="custom-dot" />,
  prevArrow: <CustomPrevArrow />,
  nextArrow: <CustomNextArrow />,
};

const Carousel = ({ medias, postId, isLiked }) => {
  const dispatch = useDispatch();

  const [mediaModal, setMediaModal] = useState(false);
  const [initialSlide, setInitialSlide] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentModalSlide, setCurrentModalSlide] = useState(0);

  const isVideo = (path) => {
    const videoExtensions = [".mp4", ".webm", ".ogg", ".mov", ".3gp"];
    return videoExtensions.some((ext) => path.toLowerCase().endsWith(ext));
  };

  const handleDoubleClick = async () => {
    if (!isLiked) {
      await dispatch(likeAPost(postId));
    }
  };

  const handleModal = (index) => {
    setInitialSlide(index);
    setCurrentModalSlide(index);
    setMediaModal(true);
  };

  const mainSettings = {
    ...settings,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
  };

  const modalSettings = {
    ...settings,
    initialSlide: initialSlide,
    adaptiveHeight: false,
    infinite: medias?.length > 1,
    swipe: true,
    beforeChange: (oldIndex, newIndex) => setCurrentModalSlide(newIndex),
  };

  return (
    <div className="carousel-wrapper">
      <Slider {...mainSettings}>
        {medias?.map((media, index) => (
          <div
            onDoubleClick={handleDoubleClick}
            onClick={() => handleModal(index)}
            key={index}
            className="carousel_item"
          >
            {isVideo(media?.path) ? (
              <video
                className="single_video"
                controls
                width="100%"
                height="auto"
                muted
              >
                <source src={serverFiles(media?.path)} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                className="single_image"
                src={serverFiles(media?.path)}
                alt={`media-${media.id}`}
              />
            )}
          </div>
        ))}
      </Slider>

      {/* Slide counter for mobile feed */}
      {medias?.length > 1 && (
        <div className="feed-carousel-counter">
          {currentSlide + 1} / {medias.length}
        </div>
      )}

      <ImageModal
        modalOpen={mediaModal}
        closeModal={() => setMediaModal(false)}
        height="fit-content"
      >
        <div className="mediaModal_wrapper">
          <Slider {...modalSettings}>
            {medias?.map((media, index) => (
              <div
                onDoubleClick={handleDoubleClick}
                key={index}
                className="carousel_item"
              >
                {isVideo(media.path) ? (
                  <video
                    className="single_video"
                    controls
                    width="100%"
                    height="auto"
                    muted
                  >
                    <source src={serverFiles(media.path)} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <ZoomableImage
                    src={serverFiles(media.path)}
                    alt={`media-${media.id}`}
                    className="single_image"
                  />
                )}
              </div>
            ))}
          </Slider>

          {/* Slide counter for modal */}
          {medias?.length > 1 && (
            <div className="modal-carousel-counter">
              {currentModalSlide + 1} / {medias.length}
            </div>
          )}
        </div>
      </ImageModal>
    </div>
  );
};

export default Carousel;

